//more config info: https://github.com/jrburke/r.js/blob/master/build/example.build.js
//NOTE: baseUrl is set via gulp. DO NOT MODIFY MANUALLY!
//NOTE: url args is set via gulp, but consider simply using rand to force dev to always load fresh even if didn't run a setenv
require.config({
    baseUrl: '/fe/dist',
	urlArgs: 'sv=1793030406892',

  /* jshint ignore:start */
  paths: {
    //actual paths
    templates: "../templates",

    //my codes
    all: "common/legacy/all",
    johngrid: "services/johngrid",
    cookieutil: "services/cookieutil",

    //3rd party vendor
    //jqueryMigrate: 'common/legacy/jquery-migrate-plugin',
    jquery:
      "common/legacy/jquery-1.11.3.min" /*note that we don't bother shimming. Load jquery into the window.*/,
    jqueryui:
      "common/legacy/jquery-ui-1.10.4.custom.min" /*Only includes components needed for autocomplete and slide effect (for home menu): http://jqueryui.com/download/#!version=1.10.4&components=1101000000100010000010000000000010*/,
    ractivejs:
      "../../bower_components/ractive/ractive-legacy.runtime.min" /*using legacy so we have IE8 support*/,
    stacktrace: "common/legacy/stacktrace",
    flashDetect: "common/legacy/flash_detect",
    superfishmenu:
      "../../bower_components/superfish/dist/js/superfish" /*note that this plugin's css is included in our "all.css". We upgraded this to work with latest jquery, but didn't need to update styling*/,
    fancyboxpack: "common/legacy/jquery.fancybox.pack",
    fancyboxmedia: "common/legacy/jquery.fancybox-media",
    bootstraptab: "common/legacy/bootstrap-tab",
    bootstrapDatePicker: "common/legacy/bootstrap-datepickerNew",
    nicEditlatest: "common/legacy/nicEdit-latest",
    lazyload: "../../bower_components/vanilla-lazyload/dist/lazyload",
    hotkeys: "common/legacy/hotkeys" /*keyboard event handling*/,
    date: "common/legacy/date",
    daterangepicker: "common/legacy/daterangepicker",
    jqBarGraph: "common/legacy/jqBarGraph.1.1.min",
    fadegallery: "common/legacy/fadegallery" /*slideshow*/,
    moment: "../../bower_components/moment/min/moment.min",

    //polyfills
    placeholder: "polyfills/jquery.placeholder.min",

    //server-side only
    rv: "../tasks/helpers/rv_withUnicodeFix", //slightly modified version of 'bower_components/rv/rv' that cleans out a unicode character that must be getting saved by visual studio
    ractive:
      "../../bower_components/ractive/ractive-legacy.min" /*full ractive is used by rv to compile our ractive templates: https://github.com/ractivejs/rv#using-ractive-runtime*/,
  },

  shim: {
    //jqueryMigrate: ['jquery'],
    all: ["fancyboxmedia", "lazyload", "daterangepicker"],
    jqueryui: ["jquery"],
    superfishmenu: ["jquery"],
    fancyboxpack: ["jquery"],
    fancyboxmedia: ["fancyboxpack"],
    bootstraptab: ["jquery"],
    bootstrapDatePicker: ["jquery"],
    placeholder: ["jquery"],
    jqBarGraph: ["jquery"],
    scrollstop: ["jquery"],
    lazyload: ["jquery"], //, 'scrollstop'],
    hotkeys: ["jquery"],
    daterangepicker: ["jquery", "date"],
    fadegallery: ["jquery"],
  },

  /* jshint ignore:end */
  waitSeconds: 120,
  stubModules: ["rv", "ractive"], //rv and full-ractive is not needed in our final output, since r.js will use rv to precompile our templates. TODO: consider also using this to do a bundling type thing--exclude big-rarely used libraries and allow require to load them in like in dev
});

var bootstrapDependencies = ["app"]; //, 'jqueryMigrate'];

//should technically check if any of the polyfills that we use are needed, but since placeholder is the newest feature we use (even needed in IE10), no sense in checking others.
var needPolyfills = document.createElement("input").placeholder === void 0; //placeholder attribute (IE 10)

if (needPolyfills) {
  bootstrapDependencies.push("polyfills");
}

require(bootstrapDependencies, function (App) {
  "use strict";
  window.app = new App();
  window.app.init(true); //important, since init expects window.app to be set
});

define("main", function(){});

